import React, { useEffect } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import i18n from "../../../i18n";

import set from "@rill/set";

import { MobileBrandingSection } from "./branding/MobileBrandingSection";
import { PressStorefrontBrandingSection } from "./branding/PressStorefrontBrandingSection";
import { SettingsBackHandler } from "../../coaching-portal/settings/components/SettingsBackHandler";
import { StorefrontBrandingSection } from "./branding/StorefrontBrandingSection";
import LogoOverlayComponent from "./LogoOverlayComponent";
import SettingsNav from "../../../parts/settings-nav";

import { checkOrganizationSectionPermission } from "../../../middleware/ensure-coach-permissions";
import { getUserToRequest } from "./manage-coaches/utils/manage-coaches-utils";
import { S3 } from "../../../constants";
import FloatingButtons from "../../../parts/FloatingButtons";
import useCompareState from "../../../hooks/useCompareState";
import { usePrevious } from "../../../hooks/usePrevious";
import DailyDashboardPreview from "./DailyDashboardPreview";
import { isValidHex } from "../../../utils/colors";
import {
  instagramHandleFromLink,
  instagramLinkFor,
  isInstagramUrl,
  isValidInstagramHandle,
  normalizeInstagramHandle,
} from "../../../utils/instagram";
import { RillContext } from "../../../rill/RillReact/share/base";

const colors = {
  dark: {
    backgroundColor: "#20262e",
    darkGrey: "#2b3139",
    white05: "#ffffff0d",
    formElementColor: "#FFFFFF",
    primary: "#FFFFFF",
    white10: "#ffffff1a",
  },
  light: {
    backgroundColor: "#f1f3f6",
    darkGrey: "#ffffff",
    white05: "#f1f3f6",
    formElementColor: "#000000",
    primary: "#000000",
    white10: "#e0e4ea",
  },
};
class BrandingSettings extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.state = {
      businessName: "",
      appStoreLink: "",
      googlePlayLink: "",
      formLogoImg: "",
      logoImg: {},
      // logoChanged is used to know if the logo was modified
      // and either send the new logoImg or the previous logoImg
      // based on that
      logoChanged: false,
      bannerImg: {},
      formBannerImg: "",
      // equivalent use of logoChange variable for the banner Img
      bannerChanged: false,
      previewImg: {},
      formPreviewImg: "",
      previewImgChanged: false,
      pressPreviewImg: {},
      formPressPreviewImg: "",
      pressPreviewImgChanged: false,
      mobileSplashImg: {},
      mobileSplashChanged: false,
      formMobileSplashImg: "",
      mobileSplashBg: {},
      mobileSplashBgChanged: false,
      formMobileSplashBg: "",
      splashOverlay: false,
      splashOverlayColor: "",
      splashOverlayOpacity: 50,
      phoneScreenImg: {},
      phoneScreenChanged: false,
      faviconChanged: false,
      favicon: {},
      formPhoneScreenImg: "",
      formFavicon: "",
      whiteBg: false,
      appMainColor: "",
      appTheme: "",
      appMainColorPicker: null,
      appSecondaryTextColor: "",
      storefrontTheme: "",
      storefrontMainColor: "",
      storefrontMainColorPicker: null,
      storefrontSecondaryTextColor: "",
      isAppDefaultColor: true,
      isSplashImgTinted: false,
      marketingSite: "",
      introVideo: "",
      introduction: "",
      communityLink: "",
      facebookLink: "",
      instagramHandle: "",
      instagramLink: "",
      twitterLink: "",
      youtubeLink: "",
      descriptionSEO: "",
      mobileAppPreview: false,
      splashLogoSrc: null,
      selection: "mobile",
      temporalSplashImg: null,
      temporalSplashBg: null,
      pressStorefrontMainColor: "",
      pressStorefrontMainColorPicker: null,
      pressStorefrontSecondaryTextColor: "",
      pressStoreFrontTheme: "",
      gymName: "",
      callLink: "",
      dayPassLink: "",
      pressDescriptionSEO: "",
      benefits: "",
      pressFacebookLink: "",
      pressInstagramLink: "",
      pressTwitterLink: "",
      pressYoutubeLink: "",
      formPressBannerImg: "",
      formGymImg: "",
      pressFavicon: {},
      pressFormFavicon: {},
      pressBannerImg: {},
      gymImg: {},
      pressFaviconChanged: false,
      pressBannerChanged: false,
      gymImgChanged: false,
      colorValidationErrors: {
        appMainColor: false,
        storefrontMainColor: false,
        pressStorefrontMainColor: false,
      },
    };
    this.initialState = null;

    this.changed = false;

    this.handleChange = this.handleChange.bind(this);
    this.handleSwitch = this.handleSwitch.bind(this);
    this.validateYoutubeLink = this.validateYoutubeLink.bind(this);
    this.validateCustomAppStoreLink =
      this.validateCustomAppStoreLink.bind(this);
    this.renderMobileSplashPreview = this.renderMobileSplashPreview.bind(this);
    this.renderMobilePreview = this.renderMobilePreview.bind(this);
    this.handleDiscard = this.handleDiscard.bind(this);
    this.updateInitialState = this.updateInitialState.bind(this);
  }

  componentDidMount() {
    const { activeUser, organizationOwner } = this.context.locals;
    const userToRequest = getUserToRequest(activeUser, organizationOwner);

    const {
      businessName,
      googlePlayLink,
      appStoreLink,
      customBranding,
      pressCustomBranding,
      appStoreListingEnable,
    } = userToRequest;
    let initialState = {};

    if (pressCustomBranding && !customBranding) {
      initialState = {
        pressStorefrontMainColor:
          pressCustomBranding.pressStorefrontMainColor || "",
        pressStorefrontSecondaryTextColor:
          pressCustomBranding.pressStorefrontSecondaryTextColor || "white",
        pressStoreFrontTheme:
          pressCustomBranding.pressStoreFrontTheme || "dark",
        gymName: pressCustomBranding.gymName || "",
        callLink: pressCustomBranding.callLink || "",
        dayPassLink: pressCustomBranding.dayPassLink || "",
        pressDescriptionSEO: pressCustomBranding.pressDescriptionSEO || "",
        benefits: pressCustomBranding.benefits || "",
        pressFacebookLink: pressCustomBranding.pressFacebookLink || "",
        pressInstagramLink: pressCustomBranding.pressInstagramLink || "",
        pressTwitterLink: pressCustomBranding.pressTwitterLink || "",
        pressYoutubeLink: pressCustomBranding.pressYoutubeLink || "",
        pressBannerImg: pressCustomBranding.pressBannerImg || {},
        formPressBannerImg: pressCustomBranding.formPressBannerImg || "",
        pressPreviewImg: pressCustomBranding.pressPreviewImg || {},
        formPressPreviewImg: pressCustomBranding.formPressPreviewImg || "",
        gymImg: pressCustomBranding.gymImg || {},
        formGymImg: pressCustomBranding.formGymImg || "",
        pressFavicon: pressCustomBranding.pressFavicon || {},
        pressFormFavicon: pressCustomBranding.pressFormFavicon || {},
        selection: "mobile",
      };
    }

    if (customBranding && !pressCustomBranding) {
      initialState = {
        businessName: businessName,
        googlePlayLink: !appStoreListingEnable
          ? ""
          : appStoreListingEnable && googlePlayLink
          ? googlePlayLink
          : "https://play.google.com/store/apps/details?id=com.mystrengthbook&hl=en_US&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1",
        appStoreLink: !appStoreListingEnable
          ? ""
          : appStoreListingEnable && appStoreLink
          ? appStoreLink
          : "https://apps.apple.com/us/app/mystrengthbook/id1337179045",
        logoImg: customBranding.logoImg || {},
        // formLogoImg is meant to mirror the variable logoImg
        // and use it to send the same values again to the PUT method
        // if the logo input was not modified
        formLogoImg: customBranding.logoImg || {},
        bannerImg: customBranding.bannerImg || {},
        // equivalente use of formLogoImg variable for the banner img
        formBannerImg: customBranding.bannerImg || "",
        previewImg: customBranding.previewImg || {},
        formPreviewImg: customBranding.previewImg || "",
        mobileSplashImg: customBranding.mobileSplashImg || {},
        formMobileSplashImg: customBranding.mobileSplashImg || "",
        mobileSplashBg: customBranding.mobileSplashBg || {},
        formMobileSplashBg: customBranding.mobileSplashBg || "",
        phoneScreenImg: customBranding.phoneScreenImg || {},
        favicon: customBranding.favicon || {},
        formFavicon: customBranding.favicon || {},
        formPhoneScreenImg: customBranding.phoneScreenImg || "",
        isAppDefaultColor: customBranding.appColorsDefault || "",
        isSplashImgTinted: customBranding.tintSplashImg || false,
        appMainColor: customBranding.appMainColor || "",
        appSecondaryTextColor: customBranding.appSecondaryTextColor,
        appTheme: customBranding.appTheme || "dark",
        communityLink: customBranding.communityLink || "",
        facebookLink: customBranding.facebookLink || "",
        instagramHandle:
          customBranding.instagramHandle ||
          instagramHandleFromLink(customBranding.instagramLink),
        instagramLink: customBranding.instagramLink || "",
        twitterLink: customBranding.twitterLink || "",
        youtubeLink: customBranding.youtubeLink || "",
        introVideo: customBranding.introVideo || "",
        introduction: customBranding.introduction || "",
        marketingSite: customBranding.marketingSite || "",
        storefrontMainColor: customBranding.storefrontMainColor || "",
        storefrontSecondaryTextColor:
          customBranding.storefrontSecondaryTextColor || "white",

        storefrontTheme: customBranding.storefrontTheme || "dark",
        whiteBg: customBranding.whiteLogoBackground || false,
        splashOverlay: !!customBranding.splashOverlayColor,
        splashOverlayColor: customBranding.splashOverlayColor || "#000000",
        splashOverlayOpacity: customBranding.splashOverlayOpacity || 70,
        descriptionSEO: customBranding.descriptionSEO,
        selection: "mobile",
      };
    }

    if (customBranding && pressCustomBranding) {
      initialState = {
        businessName: businessName,
        googlePlayLink: !appStoreListingEnable
          ? ""
          : appStoreListingEnable && googlePlayLink
          ? googlePlayLink
          : "https://play.google.com/store/apps/details?id=com.mystrengthbook&hl=en_US&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1",
        appStoreLink: !appStoreListingEnable
          ? ""
          : appStoreListingEnable && appStoreLink
          ? appStoreLink
          : "https://apps.apple.com/us/app/mystrengthbook/id1337179045",
        logoImg: customBranding.logoImg || {},
        formLogoImg: customBranding.logoImg || {},
        bannerImg: customBranding.bannerImg || {},
        formBannerImg: customBranding.bannerImg || "",
        previewImg: customBranding.previewImg || {},
        formPreviewImg: customBranding.previewImg || "",
        mobileSplashImg: customBranding.mobileSplashImg || {},
        formMobileSplashImg: customBranding.mobileSplashImg || "",
        mobileSplashBg: customBranding.mobileSplashBg || {},
        formMobileSplashBg: customBranding.mobileSplashBg || "",
        phoneScreenImg: customBranding.phoneScreenImg || {},
        favicon: customBranding.favicon || {},
        formFavicon: customBranding.favicon || {},
        formPhoneScreenImg: customBranding.phoneScreenImg || "",
        isAppDefaultColor: customBranding.appColorsDefault || "",
        isSplashImgTinted: customBranding.tintSplashImg || false,
        appMainColor: customBranding.appMainColor || "",
        appSecondaryTextColor: customBranding.appSecondaryTextColor,
        appTheme: customBranding.appTheme || "dark",
        communityLink: customBranding.communityLink || "",
        facebookLink: customBranding.facebookLink || "",
        instagramHandle:
          customBranding.instagramHandle ||
          instagramHandleFromLink(customBranding.instagramLink),
        instagramLink: customBranding.instagramLink || "",
        twitterLink: customBranding.twitterLink || "",
        youtubeLink: customBranding.youtubeLink || "",
        introVideo: customBranding.introVideo || "",
        introduction: customBranding.introduction || "",
        marketingSite: customBranding.marketingSite || "",
        storefrontMainColor: customBranding.storefrontMainColor || "",
        storefrontSecondaryTextColor:
          customBranding.storefrontSecondaryTextColor || "white",
        storefrontTheme: customBranding.storefrontTheme || "dark",
        whiteBg: customBranding.whiteLogoBackground || false,
        splashOverlay: !!customBranding.splashOverlayColor,
        splashOverlayColor: customBranding.splashOverlayColor || "#000000",
        splashOverlayOpacity: customBranding.splashOverlayOpacity || 70,
        descriptionSEO: customBranding.descriptionSEO,
        selection: "mobile",
        //press
        pressStorefrontMainColor:
          pressCustomBranding.pressStorefrontMainColor || "",
        pressStorefrontSecondaryTextColor:
          pressCustomBranding.pressStorefrontSecondaryTextColor || "white",
        pressStoreFrontTheme:
          pressCustomBranding.pressStoreFrontTheme || "dark",
        gymName: pressCustomBranding.gymName || "",
        callLink: pressCustomBranding.callLink || "",
        dayPassLink: pressCustomBranding.dayPassLink || "",
        pressDescriptionSEO: pressCustomBranding.pressDescriptionSEO || "",
        benefits: pressCustomBranding.benefits || "",
        pressFacebookLink: pressCustomBranding.pressFacebookLink || "",
        pressInstagramLink: pressCustomBranding.pressInstagramLink || "",
        pressTwitterLink: pressCustomBranding.pressTwitterLink || "",
        pressYoutubeLink: pressCustomBranding.pressYoutubeLink || "",
        pressBannerImg: pressCustomBranding.pressBannerImg || {},
        formPressBannerImg: pressCustomBranding.pressBannerImg || "",
        pressPreviewImg: pressCustomBranding.pressPreviewImg || {},
        formPressPreviewImg: pressCustomBranding.pressPreviewImg || "",
        gymImg: pressCustomBranding.gymImg || {},
        formGymImg: pressCustomBranding.gymImg || {},
        pressFavicon: pressCustomBranding.pressFavicon || {},
        pressFormFavicon: pressCustomBranding.pressFavicon || {},
      };
    }
    this.initialState = initialState;
    this.setState(initialState);
  }

  validateYoutubeLink() {
    const youtubeLongRegex =
      /(?:https?:\/\/)?(?:www\.|m\.)?youtu(?:\.be\/|be.com\/\S*(?:watch|embed)(?:(?:(?=\/[^&\s\?]+(?!\S))\/)|(?:\S*v=|v\/)))([^&\s\?]+)/;

    const URL_REGEX =
      /^(?:(?:https?):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;
    if (this.state.introVideo.length > 0) {
      if (
        URL_REGEX.test(this.state.introVideo) &&
        ((this.state.introVideo.includes("youtube") &&
          this.state.introVideo.includes("shorts")) ||
          youtubeLongRegex.test(this.state.introVideo))
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  validateCustomAppStoreLink() {
    if (!this.state.googlePlayLink && !this.state.appStoreLink) {
      return true;
    }

    if (this.state.googlePlayLink && this.state.appStoreLink) {
      if (
        this.state.googlePlayLink.includes("play.google.com/store/apps") &&
        this.state.appStoreLink.includes("apps.apple.com")
      ) {
        return true;
      } else {
        return false;
      }
    }

    return false;
  }

  handleChange(event) {
    this.changed = true;

    // sometimes this method is called directly with the target
    // from within Avatar Input
    const target = event.target || event;

    const { whiteBg, splashOverlay, isSplashImgTinted } = this.state;
    if (target.name === "whiteLogoBackground") {
      this.setState({ whiteBg: !whiteBg });
      return;
    }
    if (target.name === "appColorsDefault") {
      if (target.value === "custom") {
        this.setState({ isAppDefaultColor: false });
      } else {
        this.setState({ isAppDefaultColor: true });
      }
      return;
    }
    if (target.name === "tintSplashImg") {
      this.setState({ isSplashImgTinted: !isSplashImgTinted });
      return;
    }

    if (
      target.name === "appMainColorPicker" ||
      target.name === "appMainColor"
    ) {
      const value = target.value.trim();
      const isValid = isValidHex(value);
      this.setState((prev) => ({
        appMainColor: value,
        colorValidationErrors: {
          ...prev.colorValidationErrors,
          appMainColor: !isValid,
        },
      }));

      return;
    }

    if (
      target.name === "storefrontMainColorPicker" ||
      target.name === "storefrontMainColor"
    ) {
      const value = target.value.trim();
      const isValid = isValidHex(value);

      this.setState((prev) => ({
        storefrontMainColor: value,
        colorValidationErrors: {
          ...prev.colorValidationErrors,
          storefrontMainColor: !isValid,
        },
      }));

      return;
    }

    if (
      target.name === "pressStorefrontMainColorPicker" ||
      target.name === "pressStorefrontMainColor"
    ) {
      const value = target.value.trim();
      const isValid = isValidHex(value);

      this.setState((prev) => ({
        pressStorefrontMainColor: value,
        colorValidationErrors: {
          ...prev.colorValidationErrors,
          pressStorefrontMainColor: !isValid,
        },
      }));

      return;
    }

    if (target.name === "customBranding[logoImg]") {
      this.setState({ logoChanged: true });
    }
    if (target.name === "pressCustomBranding[pressBannerImg]") {
      this.setState({ pressBannerChanged: true });
    }
    if (target.name === "pressCustomBranding[pressPreviewImg]") {
      this.setState({ pressPreviewImgChanged: true });
    }
    if (target.name === "pressCustomBranding[gymImg]") {
      this.setState({ gymImgChanged: true });
    }
    if (target.name === "customBranding[bannerImg]") {
      this.setState({ bannerChanged: true });
    }
    if (target.name === "customBranding[previewImg]") {
      this.setState({ previewImgChanged: true });
    }
    if (target.name === "customBranding[mobileSplashImg]") {
      this.setState({
        mobileSplashChanged: true,
        temporalSplashImg: event.backgroundImage,
      });
    }
    if (target.name === "customBranding[mobileSplashBg]") {
      this.setState({
        mobileSplashBgChanged: true,
        temporalSplashBg: event.backgroundImage,
      });
    }
    if (target.name === "splashOverlay") {
      this.setState({ splashOverlay: !splashOverlay });
      return;
    }
    if (target.name === "splashOverlayColorPicker") {
      this.setState({ splashOverlayColor: target.value });
      return;
    }
    if (target.name === "customBranding[phoneScreenImg]") {
      this.setState({ phoneScreenChanged: true });
    }
    if (target.name === "customBranding[favicon]") {
      this.setState({ faviconChanged: true });
    }

    if (target.name === "pressCustomBranding[pressFavicon]") {
      this.setState({ pressFaviconChanged: true });
    }

    this.setState({ [target.name]: target.value });
  }

  handleSelection(selection) {
    this.setState({ selection });
  }

  handleSwitch(target, value) {
    this.changed = true;
    this.setState({ [target]: value });
  }

  handleDiscard() {
    this.changed = false;
    this.setState(this.initialState);
  }
  updateInitialState() {
    this.initialState = this.state;
  }
  renderMobilePreview() {
    const { t } = this.props;
    const { appTheme, isAppDefaultColor, appMainColor, appSecondaryTextColor } =
      this.state;
    return (
      <div className="section phone-template">
        <div className="background-container">
          <DailyDashboardPreview
            theme={appTheme}
            brandingColor={appMainColor}
            isDefaultColor={isAppDefaultColor}
            secondaryTextColor={appSecondaryTextColor}
          />
        </div>
        <img alt={t("branding.phoneAlt")} src="/img/iphone-template.webp" />
      </div>
    );
  }

  renderMobileSplashPreview() {
    const { t } = this.props;
    const {
      mobileSplashImg,
      mobileSplashBg,
      mobileSplashBgChanged,
      splashOverlayOpacity,
      splashOverlayColor,
      isSplashImgTinted,
      splashLogoSrc,
      splashOverlay,
      temporalSplashBg,
      temporalSplashImg,
    } = this.state;

    const backgroundImage =
      mobileSplashBg && mobileSplashBg.s3Path
        ? `${S3.PATH}${mobileSplashBg.s3Path}`
        : null;

    const allowOverlay =
      mobileSplashBgChanged || Boolean(mobileSplashBg.s3Path);

    return (
      <div className="section phone-template">
        <div
          className="background-container"
          style={{
            backgroundImage:
              temporalSplashBg || (mobileSplashBg && mobileSplashBg.s3Path)
                ? `url(${
                    temporalSplashBg ? temporalSplashBg : backgroundImage
                  })`
                : "var(--black)",
            backgroundColor: "var(--black)",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <LogoOverlayComponent
            opacity={splashOverlayOpacity}
            overlayColor={splashOverlayColor}
            withOverlay={splashOverlay && allowOverlay}
            withLogo
            logo={mobileSplashImg}
            isTinted={isSplashImgTinted}
            splashLogoSrc={
              temporalSplashImg ? temporalSplashImg : splashLogoSrc
            }
          />
        </div>
        <img alt={t("branding.phoneAlt")} src="/img/iphone-template.webp" />
      </div>
    );
  }

  render() {
    const { t } = this.props;
    const { activeUser, organizationOwner, organizationRoleName } =
      this.context.locals;
    const { selection = "mobile" } = this.state;
    const userToRequest = getUserToRequest(activeUser, organizationOwner);

    const isFe = Boolean(userToRequest.pushAccountInfo);
    const isPressCoach = Boolean(userToRequest.pressAccountInfo);
    // Team Coach can view org settings but not change them — the server
    // already rejects the POST, this just keeps the save button from
    // silently failing.
    const isReadOnly = organizationRoleName === "Team Coach";

    return (
      <main className="settings">
        <SettingsNav classNames="mobile-hidden" />
        <section className="branding-wrapper">
          <h3 className="mobile-hidden">{t("branding.title")}</h3>
          <SettingsBackHandler title={t("branding.title")} />
          <header>
            <nav role="tablist">
              <a
                aria-current={selection === "mobile" ? true : undefined}
                onClick={() => this.handleSelection("mobile")}
              >
                {t("branding.mobile")}
              </a>
              {isFe && (
                <a
                  aria-current={selection === "storefront" ? true : undefined}
                  onClick={() => this.handleSelection("storefront")}
                >
                  {t("branding.pushStorefront")}
                </a>
              )}
              {isPressCoach && (
                <a
                  aria-current={selection === "push" ? true : undefined}
                  onClick={() => this.handleSelection("push")}
                >
                  {t("branding.pressStorefront")}
                </a>
              )}
            </nav>
          </header>
          <form
            id="form-branding"
            method="POST"
            encType="multipart/form-data"
            data-noreset
            onSubmit={() => {
              this.changed = false;
              this.updateInitialState();
            }}
          >
            <input
              name="storefrontSnippets[active]"
              value={
                userToRequest.customBranding &&
                userToRequest.customBranding.storefrontSnippets
                  ? userToRequest.customBranding.storefrontSnippets.active ||
                    null
                  : null
              }
              hidden
            />
            <input
              name="storefrontSnippets[global]"
              value={
                userToRequest.customBranding &&
                userToRequest.customBranding.storefrontSnippets
                  ? userToRequest.customBranding.storefrontSnippets.global ||
                    null
                  : null
              }
              hidden
            />
            <input
              name="storefrontSnippets[paymentSuccess]"
              value={
                userToRequest.customBranding &&
                userToRequest.customBranding.storefrontSnippets
                  ? userToRequest.customBranding.storefrontSnippets
                      .paymentSuccess || null
                  : null
              }
              hidden
            />
            <MobileBrandingSection
              active={selection === "mobile"}
              handleChange={this.handleChange}
              handleSwitch={this.handleSwitch}
              locals={this.context.locals}
              renderMobilePreview={this.renderMobilePreview}
              renderMobileSplashPreview={this.renderMobileSplashPreview}
              state={this.state}
              onGradientRangeChange={({ target: { value } }) => {
                this.setState({
                  splashOverlayOpacity: parseInt(value),
                });
              }}
            />
            <StorefrontBrandingSection
              active={selection === "storefront"}
              colors={colors}
              handleChange={this.handleChange}
              handleSwitch={this.handleSwitch}
              state={this.state}
              validateYoutubeLink={this.validateYoutubeLink}
            />
            <PressStorefrontBrandingSection
              active={selection === "push"}
              colors={colors}
              handleChange={this.handleChange}
              handleSwitch={this.handleSwitch}
              state={this.state}
            />

            <Footer
              updatedState={this.state}
              handleDiscard={this.handleDiscard}
              changed={this.changed}
              readOnly={isReadOnly}
            />
          </form>
        </section>
      </main>
    );
  }
}

BrandingSettings.contextType = RillContext;
const BrandingSettingsWithI18n = withTranslation("dashboard")(BrandingSettings);

const Footer = ({ updatedState, handleDiscard, changed, readOnly = false }) => {
  const { t } = useTranslation(["dashboard", "common"]);
  const inputNames = {
    appMainColor: t("branding.primaryColor"),
    storefrontMainColor: t("branding.storefrontColor"),
    pressStorefrontMainColor: t("branding.storefrontMainColor"),
  };

  let tooltipMessage = readOnly ? t("settingsNav.readOnlyTooltip") : null;

  const errorField = Object.keys(updatedState.colorValidationErrors).find(
    (key) => updatedState.colorValidationErrors[key]
  );

  if (!readOnly && errorField) {
    const fieldName = inputNames[errorField] || t("branding.color");
    tooltipMessage = t("branding.invalidColorTooltip", {
      fieldName,
    });
  }

  const [compareBase, setCompareBase, setCurrentCompareState, hasChanged] =
    useCompareState();

  const previousState = usePrevious(updatedState);
  const previousChanged = usePrevious(changed);
  useEffect(() => {
    if (previousChanged === true && !changed) {
      setCompareBase({});
      setCurrentCompareState({});
    } else {
      Object.keys(compareBase).length === 0 &&
        changed &&
        setCompareBase(previousState);

      changed && setCurrentCompareState(updatedState);
    }
  }, [updatedState, changed]);

  return (
    <footer>
      <FloatingButtons
        failedText={t("common:discard")}
        successText={t("common:save")}
        successDisabled={
          readOnly ||
          !hasChanged ||
          Object.values(updatedState.colorValidationErrors).some(Boolean)
        }
        handleFailed={handleDiscard}
        handleSuccess={() => {
          // document.getElementById("form-branding").submit();
        }}
        classNames={"mobile-hidden"}
        label={t("branding.saveChanges")}
        submitForm={"form-branding"}
        showTooltipOnDisabled={
          readOnly ||
          Object.values(updatedState.colorValidationErrors).some(Boolean)
        }
        tooltipMessage={tooltipMessage}
      />
    </footer>
  );
};
const BrandingSettingsController = (app) => {
  app
    .get(
      "/branding",
      set("heading", "Edit Profile"),
      (ctx, next) =>
        checkOrganizationSectionPermission(
          ctx,
          next,
          "settings",
          "/coaching-portal/settings",
          ["Owner", "Admin", "Team Coach"]
        ),
      ({ res }) => (res.body = <BrandingSettingsWithI18n />)
    )
    .post(
      "/branding",
      (ctx, next) =>
        checkOrganizationSectionPermission(
          ctx,
          next,
          "settings",
          "/coaching-portal/settings",
          ["Owner", "Admin"]
        ),
      async ({ req, locals, res, api, flash, assert, momentTZ }) => {
        const { body, files } = req;
        const userToRequest = getUserToRequest(
          locals.activeUser,
          locals.organizationOwner
        );

        // init gym location and gym contract section
        const pressCustomBrandingContent = userToRequest.pressCustomBranding;
        const gymContract =
          pressCustomBrandingContent && pressCustomBrandingContent.gymContract
            ? pressCustomBrandingContent.gymContract
            : "";
        const gymLocations =
          pressCustomBrandingContent && pressCustomBrandingContent.gymLocations
            ? pressCustomBrandingContent.gymLocations
            : [];
        // end gym location and gym contract section
        delete body.pressStorefrontMainColorPicker;
        delete body.storefrontMainColorPicker;
        delete body.appMainColorPicker;
        delete body.splashOverlayColorPicker;
        delete body.splashOverlay;

        let newBody = {};

        newBody.businessName = body.businessName;
        delete body.businessName;

        newBody.googlePlayLink = body.googlePlayLink;
        delete body.googlePlayLink;

        newBody.appStoreLink = body.appStoreLink;
        delete body.appStoreLink;

        body.appColorsDefault =
          body.isAppDefaultColor === "default" ? true : false;
        delete body.isAppDefaultColor;

        delete body.mobileAppPreview;

        // Store the bare handle; keep the Instagram link pointing at it unless
        // the coach set a non-Instagram link (e.g. a link-in-bio page).
        const instagramHandle = normalizeInstagramHandle(body.instagramHandle);
        if (instagramHandle && !isValidInstagramHandle(instagramHandle)) {
          flash("error", i18n.t("dashboard:branding.instagramHandleInvalid"));
          return res.redirect("/coaching-portal/settings/branding");
        }
        body.instagramHandle = instagramHandle;
        if (
          instagramHandle &&
          (!body.instagramLink || isInstagramUrl(body.instagramLink))
        ) {
          body.instagramLink = instagramLinkFor(instagramHandle);
        }

        if (!body.logoChanged) {
          body.logoImg = {
            file: body.formLogoImgFile,
            type: body.formLogoImgType,
            name: body.formLogoImgName,
            s3Path: body.formLogoImgS3Path,
          };
        }
        delete body.formLogoImgFile;
        delete body.formLogoImgType;
        delete body.formLogoImgName;
        delete body.formLogoImgS3Path;
        delete body.logoChanged;

        if (!body.bannerChanged) {
          body.bannerImg = {
            file: body.formBannerImgFile,
            type: body.formBannerImgType,
            name: body.formBannerImgName,
            s3Path: body.formBannerImgS3Path,
          };
        }
        delete body.formBannerImgFile;
        delete body.formBannerImgType;
        delete body.formBannerImgName;
        delete body.formBannerImgS3Path;
        delete body.bannerChanged;

        if (!body.previewImgChanged) {
          body.previewImg = {
            file: body.formPreviewImgFile,
            type: body.formPreviewImgType,
            name: body.formPreviewImgName,
            s3Path: body.formPreviewImgS3Path,
          };
        }
        delete body.formPreviewImgFile;
        delete body.formPreviewImgType;
        delete body.formPreviewImgName;
        delete body.formPreviewImgS3Path;
        delete body.previewImgChanged;

        if (!body.mobileSplashChanged) {
          body.mobileSplashImg = {
            file: body.formMobileSplashImgFile,
            type: body.formMobileSplashImgType,
            name: body.formMobileSplashImgName,
            s3Path: body.formMobileSplashImgS3Path,
          };
        }

        delete body.formMobileSplashImgFile;
        delete body.formMobileSplashImgType;
        delete body.formMobileSplashImgName;
        delete body.formMobileSplashImgS3Path;
        delete body.mobileSplashChanged;

        if (!body.mobileSplashBgChanged) {
          body.mobileSplashBg = {
            file: body.formMobileSplashBgFile,
            type: body.formMobileSplashBgType,
            name: body.formMobileSplashBgName,
            s3Path: body.formMobileSplashBgS3Path,
          };
        }

        delete body.formMobileSplashBgFile;
        delete body.formMobileSplashBgType;
        delete body.formMobileSplashBgName;
        delete body.formMobileSplashBgS3Path;
        delete body.mobileSplashBgChanged;

        if (!body.phoneScreenChanged) {
          body.phoneScreenImg = {
            file: body.formPhoneScreenImgFile,
            type: body.formPhoneScreenImgType,
            name: body.formPhoneScreenImgName,
            s3Path: body.formPhoneScreenImgS3Path,
          };
        }

        delete body.formPhoneScreenImgFile;
        delete body.formPhoneScreenImgType;
        delete body.formPhoneScreenImgName;
        delete body.formPhoneScreenImgS3Path;
        delete body.phoneScreenChanged;

        if (!body.faviconChanged) {
          body.favicon = {
            file: body.formFaviconFile,
            type: body.formFaviconType,
            name: body.formFaviconName,
            s3Path: body.formFaviconS3Path,
          };
        }

        delete body.formFaviconFile;
        delete body.formFaviconType;
        delete body.formFaviconName;
        delete body.formFaviconS3Path;
        delete body.faviconChanged;

        if (!body.pressFaviconChanged) {
          body.pressFavicon = {
            file: body.pressFormFaviconFile,
            type: body.pressFormFaviconType,
            name: body.pressFormFaviconName,
            s3Path: body.pressFormFaviconS3Path,
          };
        }

        if (!body.gymImgChanged) {
          body.gymImg = {
            file: body.formGymImgFile,
            type: body.formGymImgType,
            name: body.formGymImgName,
            s3Path: body.formGymImgS3Path,
          };
        }

        if (!body.pressBannerChanged) {
          body.pressBannerImg = {
            file: body.formPressBannerImgFile,
            type: body.formPressBannerImgType,
            name: body.formPressBannerImgName,
            s3Path: body.formPressBannerImgS3Path,
          };
        }

        if (!body.pressPreviewImgChanged) {
          body.pressPreviewImg = {
            file: body.formPressPreviewImgFile,
            type: body.formPressPreviewImgType,
            name: body.formPressPreviewImgName,
            s3Path: body.formPressPreviewImgS3Path,
          };
        }

        const pressBody = {
          pressStoreFrontTheme: body.pressStoreFrontTheme,
          pressStorefrontMainColor: body.pressStorefrontMainColor,
          gymName: body.gymName,
          pressStorefrontSecondaryTextColor:
            body.pressStorefrontSecondaryTextColor,
          pressBannerImg: body.pressBannerImg,
          pressPreviewImg: body.pressPreviewImg,
          gymImg: body.gymImg,
          pressFavicon: body.pressFavicon,
          pressDescriptionSEO: body.pressDescriptionSEO,
          benefits: body.benefits,
          callLink: body.callLink,
          dayPassLink: body.dayPassLink,
          pressInstagramLink: body.pressInstagramLink,
          pressYoutubeLink: body.pressYoutubeLink,
          pressTwitterLink: body.pressTwitterLink,
          pressFacebookLink: body.pressFacebookLink,
          gymContract,
          gymLocations,
        };

        delete body.benefits;
        delete body.callLink;
        delete body.dayPassLink;
        delete body.pressDescriptionSEO;
        delete body.pressFacebookLink;
        delete body.pressInstagramLink;
        delete body.pressStoreFrontTheme;
        delete body.pressStorefrontMainColor;
        delete body.pressStorefrontSecondaryTextColor;
        delete body.pressTwitterLink;
        delete body.pressYoutubeLink;
        delete body.gymName;
        delete body.pressFormFaviconFile;
        delete body.pressFormFaviconType;
        delete body.pressFormFaviconName;
        delete body.pressFormFaviconS3Path;
        delete body.pressFaviconChanged;
        delete body.formGymImgFile;
        delete body.formGymImgType;
        delete body.formGymImgName;
        delete body.formGymImgS3Path;
        delete body.gymImgChanged;
        delete body.formPressBannerImgFile;
        delete body.formPressBannerImgType;
        delete body.formPressBannerImgName;
        delete body.formPressBannerImgS3Path;
        delete body.pressBannerChanged;
        delete body.gymImg;
        delete body.pressBannerImg;
        delete body.pressFavicon;
        delete body.formPressPreviewImgFile;
        delete body.formPressPreviewImgType;
        delete body.formPressPreviewImgName;
        delete body.formPressPreviewImgS3Path;
        delete body.pressPreviewImgChanged;
        delete body.pressPreviewImg;

        newBody.customBranding = Object.assign({}, body);
        newBody.pressCustomBranding = Object.assign({}, pressBody);

        try {
          await api(`user/${userToRequest._id}`, {
            method: "PUT",
            body: newBody,
            files,
          });
          flash("success", i18n.t("auth:user.updatedSuccess"));
        } catch (e) {
          flash("error", e.message), 10;
        }

        res.redirect("/coaching-portal/settings/branding");
      }
    );
};

export default BrandingSettingsController;
